import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/js/bootstrap.bundle";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle";
window.bootstrap = bootstrap;
import "@/assets/scss/app.scss";
import VueApexCharts from "vue3-apexcharts";
import VueFeather from "vue-feather";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
// import { createI18n } from 'vue-i18n'
import HttpService from "./services/base/HttpService";
import StorageConfig from "./services/config/StorageConfig";
import en from "./locales/en.json";
import pt from "./locales/fr.json";
import fr from "./locales/pt.json";
import es from "./locales/es.json";
import { defaultLocale, localeOptions } from "./constants/config";
import Breadcrumbs from "./components/bread_crumbs";
import Labels from "./components/label";

const messages = { en: en, es: es, pt: pt, fr: fr };
const locale =
  localStorage.getItem("currentLanguage") &&
  localeOptions.filter((x) => x.id === localStorage.getItem("currentLanguage"))
    .length > 0
    ? localStorage.getItem("currentLanguage")
    : defaultLocale;

if (StorageConfig.getData()) {
  HttpService.setHeader();
}

createApp(App)
  .use(router)
  .use(store)
  .component(VueFeather.name, VueFeather)
  .component("Breadcrumbs", Breadcrumbs)
  .component("Labels", Labels)
  .component("apexchart", VueApexCharts)
  .component("multiselect", Multiselect)
  .mount("#app");
